import inicio from '../menu-sections/inicio'
import nosotros from '../menu-sections/nosotros'
import ayuda from '../menu-sections/ayuda'
import oferta from '../menu-sections/oferta'
import contacto from '../menu-sections/contacto'

// Array of sections
export default [...inicio, ...nosotros, ...oferta, ...ayuda, ...contacto]
